/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusDeviceControlDto
 */
export interface NovitusDeviceControlDto {
    /**
     * Otworz szufladę po wydrukowaniu
     * @type {boolean}
     * @memberof NovitusDeviceControlDto
     */
    open_drawer?: boolean;
    /**
     * Podaj papier po wydrukowaniu
     * @type {boolean}
     * @memberof NovitusDeviceControlDto
     */
    feed_after_printout?: boolean;
    /**
     * Tryb cięcia papieru
     * @type {string}
     * @memberof NovitusDeviceControlDto
     */
    paper_cut?: NovitusDeviceControlDtoPaperCutEnum;
    /**
     * Wyślij do monitora aktywności
     * @type {boolean}
     * @memberof NovitusDeviceControlDto
     */
    send_to_activity_monitor?: boolean;
}


/**
 * @export
 */
export const NovitusDeviceControlDtoPaperCutEnum = {
    none: 'none',
    full: 'full',
    part: 'part'
} as const;
export type NovitusDeviceControlDtoPaperCutEnum = typeof NovitusDeviceControlDtoPaperCutEnum[keyof typeof NovitusDeviceControlDtoPaperCutEnum];


/**
 * Check if a given object implements the NovitusDeviceControlDto interface.
 */
export function instanceOfNovitusDeviceControlDto(value: object): value is NovitusDeviceControlDto {
    return true;
}

export function NovitusDeviceControlDtoFromJSON(json: any): NovitusDeviceControlDto {
    return NovitusDeviceControlDtoFromJSONTyped(json, false);
}

export function NovitusDeviceControlDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusDeviceControlDto {
    if (json == null) {
        return json;
    }
    return {
        
        'open_drawer': json['open_drawer'] == null ? undefined : json['open_drawer'],
        'feed_after_printout': json['feed_after_printout'] == null ? undefined : json['feed_after_printout'],
        'paper_cut': json['paper_cut'] == null ? undefined : json['paper_cut'],
        'send_to_activity_monitor': json['send_to_activity_monitor'] == null ? undefined : json['send_to_activity_monitor'],
    };
}

export function NovitusDeviceControlDtoToJSON(value?: NovitusDeviceControlDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'open_drawer': value['open_drawer'],
        'feed_after_printout': value['feed_after_printout'],
        'paper_cut': value['paper_cut'],
        'send_to_activity_monitor': value['send_to_activity_monitor'],
    };
}

